module.exports = __webpack_public_path__ + "static/media/team18.67c864fb.png";